module.exports = "pegasus_template/assets/themecapture1/webinar/102.png";